export const BREAKPOINTS = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
});

export const USER_TYPES = Object.freeze({
  STUDENT: 'student',
  INSTRUCTOR: 'instructor',
  ADMIN_INFO_INSTRUCTOR: 'adminInfoInstructor',
  ADMIN_INSTRUCTOR: 'adminInstructor',
  ADMIN_STUDENT: 'adminStudent',
  REEGISTRATION_STUDENT: 'administrationStudent',
});

export const USER_TYPE_ID_NAMES = Object.freeze({
  [USER_TYPES.STUDENT]: 'studentId',
  [USER_TYPES.INSTRUCTOR]: 'instructorId',
  [USER_TYPES.ADMIN_INFO_INSTRUCTOR]: 'adminInfoInstructorId',
  [USER_TYPES.ADMIN_INSTRUCTOR]: 'adminInstructorId',
  [USER_TYPES.ADMIN_STUDENT]: 'adminStudentId',
  [USER_TYPES.REEGISTRATION_STUDENT]: 'administrationStudentId',
});

export const MODALS = Object.freeze({
  EVENT_CONFIRMATION: 'event-confirmation',
  QUALITY_RATING: 'quality-rating',
  QUESTIONS: 'questions',
  STUDENT_RATING_INFO: 'student-rating-info',
  INSTRUCTOR_RATING_INFO: 'instructor-rating-info',
});
